import React from "react";
import { Brain, Users, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Schnelligkeit",
  description: "Durch optimierte Prozesse und eine intelligente Routenplanung garantieren wir die pünktliche Zustellung Ihrer Sendungen.",
  icon: Sun
}, {
  title: "Sicherheit",
  description: "Wir behandeln jedes Gut mit höchster Sorgfalt. Von Antiquitäten bis Expressfracht – Ihre Ware ist bei uns bestens geschützt.",
  icon: Users
}, {
  title: "Präzision",
  description: "Unsere Logistikexperten planen jeden Schritt bis ins kleinste Detail, um einen reibungslosen und fehlerfreien Ablauf zu sichern.",
  icon: Brain
}];
export default function KeyBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="28912" id="warum-erzwerk-logistik" className="bg-background py-[120px] relative overflow-hidden text-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 font-default tracking-tight">
            Warum ErzWerk Logistik?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Ihr Partner für Transportlösungen, die durch Schnelligkeit, Sicherheit und Präzision überzeugen.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-700 ease-out", isVisible ? "opacity-100 scale-100" : "opacity-0 scale-[1.02]")}>
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="group relative flex flex-col items-start p-8 md:border-r border-border/40 last:md:border-r-0 transition-all duration-300">
              <div className="mb-6 text-chart-1">
                <benefit.icon strokeWidth={2} className="w-8 h-8" />
              </div>
              
              <h3 className="text-xl font-bold text-foreground mb-3 font-default">
                {benefit.title}
              </h3>
              
              <p className="text-muted-foreground leading-relaxed font-sans text-base">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}